import * as React from "react";
import { useMediaQuery } from "react-responsive";
import { desktopBreakpoint } from "components/Mediaqueries";
import NavMobile from "./NavMobile";
import NavDesktop from "./NavDesktop";

const Nav = () => {
  // CSS selects the visible menu while both versions are present in the server HTML.
  const [isReady, setIsReady] = React.useState(false);
  const isDesktop = useMediaQuery(desktopBreakpoint);

  React.useEffect(() => {
    setIsReady(true);
  }, []);

  return (
    <>
      {(!isReady || !isDesktop) && <NavMobile />}
      {(!isReady || isDesktop) && <NavDesktop />}
    </>
  );
};

export default Nav;
